(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients-flavors"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-flavors-section]');
    if (!section) return;
    var items = section.querySelectorAll('[data-flavor-index]');
    var imgs = section.querySelectorAll('[data-flavor-img]');
    var currentIdx = 0;
    var autoTimer = null;

    function activateFlavor(idx) {
      items.forEach(function(i) { i.classList.remove('is-active'); });
      imgs.forEach(function(i) { i.classList.remove('is-active'); });
      var item = section.querySelector('[data-flavor-index="' + idx + '"]');
      var img = section.querySelector('[data-flavor-img="' + idx + '"]');
      if (item) item.classList.add('is-active');
      if (img) img.classList.add('is-active');
      currentIdx = idx;
    }

    function startAuto() {
      autoTimer = setInterval(function() {
        activateFlavor((currentIdx + 1) % items.length);
      }, 3000);
    }

    items.forEach(function(item) {
      item.addEventListener('click', function() {
        clearInterval(autoTimer);
        autoTimer = null;
        activateFlavor(parseInt(item.getAttribute('data-flavor-index'), 10));
      });
    });

    startAuto();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-text-reveal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.scroll-reveal-text');
    
    sections.forEach(function(section) {
      const contentEl = section.querySelector('.scroll-reveal-text__content');
      if (!contentEl) return;
      
      const text = contentEl.getAttribute('data-reveal-text');
      if (!text) return;
      
      // Clear noscript and prepare container
      contentEl.innerHTML = '';
      
      // Split text into words then characters to prevent mid-word wrapping issues
      const words = text.split(' ');
      
      words.forEach(function(word, wordIndex) {
        const wordEl = document.createElement('span');
        wordEl.className = 'scroll-reveal-text__word';
        
        const chars = word.split('');
        chars.forEach(function(char) {
          const charEl = document.createElement('span');
          charEl.className = 'scroll-reveal-text__char';
          charEl.textContent = char;
          wordEl.appendChild(charEl);
        });
        
        contentEl.appendChild(wordEl);
        
        // Add a space after the word, except for the very last word
        if (wordIndex < words.length - 1) {
          const spaceEl = document.createElement('span');
          spaceEl.className = 'scroll-reveal-text__char scroll-reveal-text__space';
          spaceEl.textContent = ' ';
          contentEl.appendChild(spaceEl);
        }
      });
      
      const charElements = section.querySelectorAll('.scroll-reveal-text__char');
      const totalChars = charElements.length;
      const spacer = section.querySelector('.scroll-reveal-text__spacer');
      
      function updateReveal() {
        if (!spacer) return;
        
        const rect = spacer.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const scrollableDistance = spacer.offsetHeight - windowHeight;
        
        if (scrollableDistance <= 0) return;
        
        let scrolled = -rect.top;
        let progress = scrolled / scrollableDistance;
        
        // Clamp progress between 0 and 1
        progress = Math.max(0, Math.min(1, progress));
        
        // Optionally add a small offset so it starts revealing a bit after you start scrolling
        // and finishes a bit before the very end.
        let offsetProgress = (progress - 0.1) * 1.25; 
        offsetProgress = Math.max(0, Math.min(1, offsetProgress));
        
        const litCount = Math.floor(offsetProgress * totalChars);
        
        charElements.forEach(function(char, index) {
          if (index < litCount) {
            char.classList.add('is-lit');
          } else {
            char.classList.remove('is-lit');
          }
        });

        // Show button once scroll reveal completes
        const ctaWrapper = section.querySelector('.scroll-reveal-text__cta-wrapper');
        if (ctaWrapper) {
          if (offsetProgress >= 0.98) {
            ctaWrapper.classList.add('is-visible');
          } else {
            ctaWrapper.classList.remove('is-visible');
          }
        }
      }
      
      window.addEventListener('scroll', function() {
        requestAnimationFrame(updateReveal);
      });
      
      window.addEventListener('resize', function() {
        requestAnimationFrame(updateReveal);
      });
      
      // Initial trigger
      updateReveal();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
